import {TYPE_SET_OPEN_CHAT} from "app/redux/chats/chatsTypes";

export const actionSetActiveChat = (chatId=null) => ({
  type: TYPE_SET_OPEN_CHAT,
  payload: {
    chatId,
  },
});
